import React, { useEffect, useState } from "react";
import type { FormProps } from 'antd';
import { Link } from "react-router-dom";
import { FetchWithAuth } from "digimaker-ui/util";
import { Button, Divider, Checkbox, Form, Input, Select, message, InputNumber } from 'antd';
import {useParams} from 'react-router-dom'
type FieldType = {
    title?: string;
    product_number?: string | number;
    category?: string;
    price?: string | number
};

const EditProduct: React.FC = () => {
    const {id} = useParams();
    const [form] = Form.useForm();
    const [product, setProduct] = useState<Object>();
    const [messageApi, contextHolder] = message.useMessage();

    const getDetail: Function = async () => {
        let res = await FetchWithAuth(`/api/content/get/product/${id}`)
        if (!res.error) {
            form.setFieldsValue(res.data)
        }
    };

    const onFinish: FormProps<FieldType>['onFinish'] = (values) => {
        if (Object.prototype.toString.call(values.category) === '[object Object]') {
            values.category = values.category['value']
        };
        FetchWithAuth(`/api/content/update/product/${id}`, {
            method: "POST",
            body: JSON.stringify(values),
        }).then(res => {
            if(!res.error){
                message.success({
                    content:'提交成功'
                })
            }else{
                message.error({
                    content:res.data.message
                })
            }
            
        })
    };

    const onFinishFailed: FormProps<FieldType>['onFinishFailed'] = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };


    useEffect(() => {
        getDetail()
    })
    return (
        <div>
            <div className="header-container">
                <h2>编辑产品</h2>
            </div>
            <div>
                <Form

                    form={form}
                    name="product"
                    labelCol={{ span: 8 }}
                    wrapperCol={{ span: 16 }}
                    style={{ maxWidth: 600 }}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off"
                >
                    <Form.Item<FieldType>
                        label="名称"
                        name="title"
                        rules={[{ required: true, message: '请输入产品名称' }]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item<FieldType>
                        label="产品号"
                        name="product_number"
                        rules={[{ required: true, message: '请输入产品号' }]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item<FieldType>
                        label="分类"
                        name="category"
                        rules={[{ required: true, message: '请选择分类' }]}
                    >
                        <Select>
                            <Select.Option value="a">A</Select.Option>
                            <Select.Option value="b">B</Select.Option>
                            <Select.Option value="c">C</Select.Option>
                        </Select>
                    </Form.Item>
                    <Form.Item<FieldType>
                        label="价格"
                        name="price"
                        rules={[{ required: true, message: '请输入价格' }]}
                    >
                        <InputNumber min={1} />
                    </Form.Item>
                    <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                        <Button type="primary" htmlType="submit">
                            提交
                        </Button>
                        <Link to={"/product/list"}>
                            {" "}
                            <Button style={{ marginLeft: '12px' }}>
                                返回
                            </Button>
                        </Link>

                    </Form.Item>
                </Form>
            </div>
        </div>
    )

}

export default EditProduct